// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var forOf   = require('./$.for-of')
  , classof = require('./$.classof');
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    var arr = [];
    forOf(this, false, arr.push, arr);
    return arr;
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.collection-to-json.js
 ** module id = 270
 ** module chunks = 0
 **/